module.exports = __webpack_public_path__ + "static/media/reminder.99c79b0a.svg";